import { render } from "./BattleShipModel.vue?vue&type=template&id=432e3d2c&scoped=true"
import script from "./BattleShipModel.vue?vue&type=script&lang=js"
export * from "./BattleShipModel.vue?vue&type=script&lang=js"

import "./BattleShipModel.vue?vue&type=style&index=0&id=432e3d2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432e3d2c"]])

export default __exports__